/**
 * `randomUUID()` shape as a bare pattern, so it can be embedded in the larger
 * regexes that describe storage keys and download paths.
 *
 * Shared because every ephemeral-object family (exports, chat uploads) names its
 * objects with a UUID that becomes a PATH SEGMENT — one definition keeps the id
 * a producer mints and the id a consumer accepts from drifting apart.
 */ export const UUID_PATTERN = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
export const UUID_REGEX = new RegExp(`^${UUID_PATTERN}$`, 'i');

//# sourceMappingURL=uuid.js.map